import { Description } from "views/ShipStation/Description";

export const SETTINGS = [
  {
    apiName: "configData",
    component: "ShipStation",
    DescriptionComponent: Description,
  },
];
